import React from "react";
import constant from "lodash/constant";
import noop from "lodash/noop";
export var AccordionContext = React.createContext({
  isAccordionOpen: constant(!1),
  toggleAccordionOpen: noop,
  stateCallBack: noop,
  showFrame: !1
});